import React, { useEffect } from 'react';
import BookingWalkthrough from './BookingWalkthrough';
import Gallery from './Gallery';
import Testimonials from './Testimonials';
import FAQ from './FAQ';
import Footer from './Footer';

const BookFriendsFamilyPage = () => {
  // Meta Pixel ViewContent tracking
  useEffect(() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_type: 'product',
        content_name: 'Friends & Family Booking Page',
        content_category: 'Friends & Family Discount',
        value: 599,
        currency: 'CAD'
      });
    }
  }, []);

  return (
    <div>
      {/* Friends & Family Header */}
      <div className="bg-gradient-to-r from-purple-900/50 to-blue-900/50 py-6 px-4 text-center border-b border-purple-500/30">
        <div className="container mx-auto">
          <span className="inline-block px-4 py-1 bg-purple-500/20 rounded-full text-purple-300 text-sm font-semibold mb-2">
            Friends & Family Exclusive
          </span>
          <h1 className="text-2xl md:text-3xl font-bold text-white mb-1">
            25% Off All Services
          </h1>
          <p className="text-gray-300 text-sm">
            Thank you for being part of the Pro-Wash family
          </p>
        </div>
      </div>

      {/* Hidden SEO content - invisible but tells crawlers not to index */}
      <div className="sr-only">
        <meta name="robots" content="noindex, nofollow" />
        <h2>Friends and Family Exclusive Booking</h2>
      </div>

      {/* Booking with Friends & Family discount flag */}
      <BookingWalkthrough isFriendsFamilyDiscount={true} />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Footer />
    </div>
  );
};

export default BookFriendsFamilyPage;
